import { zora as viemZora } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const zora = {
  displayName: 'Zora',
  runtime: 'evm',
  viemChain: viemZora,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'zora' },
    qnStreams: {
      networkKey: 'zora-mainnet',
    },
    pimlico: { chainSlug: 'zora' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
